import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import UpdatePasswordForm from './UpdatePasswordForm/UpdatePasswordForm';
import UpdateDetailsForm from './UpdateDetailsForm/UpdateDetailsForm';
import PageTitleSection from '../../components/PageTitleSection/PageTitleSection';
import PageContentContainer from '../../components/PageContentContainer/PageContentContainer';
import CustomTabs from '../../components/CustomTabs/CustomTabs';

export type UpdateTab = 'password' | 'details';

export default function ProfilePage(): React.ReactElement {
  const [tab, setTab] = React.useState<UpdateTab>('details');

  const handleTabChange = (newValue: string): void => {
    setTab(newValue as UpdateTab);
  };

  const handleDetailsFormChange = (
    _event: React.SyntheticEvent,
    newValue: UpdateTab
  ): void => {
    setTab(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Japeto - Profile</title>
      </Helmet>
      <PageTitleSection title='Profile' />
      <PageContentContainer>
        <CustomTabs
          constrainWidth={false}
          hasContentBox
          tabs={[
            {
              label: 'Personal info',
              value: 'details',
              content: (
                <UpdateDetailsForm handleChange={handleDetailsFormChange} />
              )
            },
            {
              label: 'Password',
              value: 'password',
              content: <UpdatePasswordForm />
            }
          ]}
          value={tab}
          onValueChange={handleTabChange}
        />
      </PageContentContainer>
    </>
  );
}
